import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./badge.css.ts.vanilla.css-mistica.js";
var _ = "_17szrmd2 _1y2v1nfbx _1y2v1nfcd _1y2v1nf4f", n = "_17szrmd6", f = "_17szrmd4 _17szrmd2 _1y2v1nfbx _1y2v1nfcd _1y2v1nf4f _1y2v1nfb5 _1y2v1nfbk _1y2v1nfbe", b = "_1y2v1nfb0", y = "_1y2v1nfaz _1y2v1nfb9";
export { _ as badge, n as badgeBigNumber, f as badgeNumber, b as badgeWithChildren, y as container };
